import { render, staticRenderFns } from "./message-collection.vue?vue&type=template&id=4b377878&scoped=true"
import script from "./message-collection.vue?vue&type=script&lang=ts"
export * from "./message-collection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b377878",
  null
  
)

export default component.exports